export default __webpack_public_path__ + "static/media/6.d88aaaac.jpg";